import "./App.css";
import { Login } from "./Components/Admin-Creating-New-Event/LoginPages/Login/Login";
import { Layout } from "./MainLayout/Layout/Layout";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { Sidebar } from "./MainLayout/Sidebar/Sidebar";
import { ForgetPassword } from "./Components/Admin-Creating-New-Event/LoginPages/ForgetPassword/ForgetPassword";
import { Register } from "./Components/Admin-Creating-New-Event/LoginPages/Register/Register";
import { Dashboard } from "./Components/Admin-Creating-New-Event/Dashboard/Dashboard";
import { MyEvents } from "./Components/Admin-Creating-New-Event/MyEvents/MyEvent/MyEvents";
import { AdminProfile } from "./Components/Admin-Creating-New-Event/AdminProfile/AdminProfile";
import { TitleBar } from "./Components/Global/TitleBar/TitleBar";
import { RegistrationForm } from "./Components/Admin-Creating-New-Event/MyEvents/RegistrationForm/RegistrationForm";
import { CreateNewEvent } from "./Components/Admin-Creating-New-Event/MyEvents/CreateNewEvent/CreateNewEvent";
import { StripeSetting } from "./Components/Admin-Creating-New-Event/MyEvents/StripeSetting/StripeSetting";
import { EventLivePreview } from "./Components/EventLivePreview/EventLivePreview";
import { useSelector } from "react-redux";
import { Otp } from "./Components/Admin-Creating-New-Event/LoginPages/Otp/Otp";
import { NewPassword } from "./Components/Admin-Creating-New-Event/LoginPages/NewPassword/NewPassword";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AwardCategories } from "./Components/Admin-Creating-New-Event/MyEvents/AwardCategories/AwardCategories";
import { CreateNewEventPost } from "./Components/Admin-Creating-New-Event/MyEvents/CreateNewEvent/CreateNewEventPost";
import { AwardCategoriesPost } from "./Components/Admin-Creating-New-Event/MyEvents/AwardCategories/AwardCategoriesPost";
import { Test } from "./Components/Admin-Creating-New-Event/Test/Test";
import { UserRegister } from "./Components/User-Flow-While-Registration/UserLoginPages/UserRegister/UserRegister";
import { UserLogin } from "./Components/User-Flow-While-Registration/UserLoginPages/UserLogin/UserLogin";
import { UserSubmissionDetails } from "./Components/User-Flow-While-Registration/UserSubmissionDetails/UserSubmissionDetails";
import { UserRegistrationProfile } from "./Components/User-Flow-While-Registration/UserRegistrationProfile/UserRegistrationProfile";
import { UserDashboard } from "./Components/User-Flow-While-Registration/UserDashboard/UserDashboard";
import { UserTitlebar } from "./Components/Global/User-Flow/UserTitleBar/UserTitleBar";
import { UserPendingPayment } from "./Components/User-Flow-While-Registration/UserPendingPayment/UserPendingPayment";
import { UserBottomBar } from "./Components/Global/User-Flow/UserBottomBar/UserBottomBar";
import { UserForgetPassword } from "./Components/User-Flow-While-Registration/UserLoginPages/UserForgetPassword/UserForgetPassword";
import { UserNewPassword } from "./Components/User-Flow-While-Registration/UserLoginPages/UserNewPassword/UserNewPassword";
import { UserOtp } from "./Components/User-Flow-While-Registration/UserLoginPages/UserOTP/UserOtp";
import EditFieldModal from "./Components/Admin-Creating-New-Event/MyEvents/RegistrationForm/RegistrationChild/EditFieldModal";
import FormCanvas from "./Components/Admin-Creating-New-Event/MyEvents/RegistrationForm/RegistrationChild/FormCanvas";
import FormPreview from "./Components/Admin-Creating-New-Event/MyEvents/RegistrationForm/RegistrationChild/FormPreview";
import Side from "./Components/Admin-Creating-New-Event/MyEvents/RegistrationForm/RegistrationChild/Side";
import LoaderDot from "./Components/LoaderDot";
import { LoadingProvider } from "./Components/LoadingContext";

import { Coupans } from "./Components/Admin-Flow-While-Existing-Event/Coupans/Coupans";
import { TopBar } from "./Components/Admin-Flow-While-Existing-Event/TopBar/TopBar";
import { Forms } from "./Components/Admin-Flow-While-Existing-Event/ManageEvent/Forms/Forms/Forms";
import { EventDetails } from "./Components/Admin-Flow-While-Existing-Event/ManageEvent/EventDetails/EventDetail/EventDetails";
import { SubmissionId } from "./Components/Admin-Flow-While-Existing-Event/ManageEvent/EventDetails/SumbissionId/SubmissionId";
import { BackdoorAccess } from "./Components/Admin-Flow-While-Existing-Event/ManageEvent/EventDetails/BackdoorAccess/BackdoorAccess";
import { AwardDirectory } from "./Components/Admin-Flow-While-Existing-Event/ManageEvent/EventDetails/AwardDirectory/AwardDirectory";
import { JuryRound } from "./Components/Admin-Flow-While-Existing-Event/ManageJury/JuryRound/JuryRounds/JuryRound";
import { JuryRoundExistingData } from "./Components/Admin-Flow-While-Existing-Event/ManageJury/JuryRound/JuryRoundExistingData/JuryRoundExistingData";
// import { CreateJuryRound } from "./Components/Admin-Flow-While-Existing-Event/CreateJuryRound/CreateJuryRound";
// import { CreateJuryRoundPost } from "./Components/Admin-Flow-While-Existing-Event/CreateJuryRound/CreateJuryRoundPost";

import { ViewGroup } from "./Components/Admin-Flow-While-Existing-Event/ManageJury/JuryRound/ViewGroup/ViewGroup";
import { ShortListEntryForm } from "./Components/Admin-Flow-While-Existing-Event/ManageJury/JuryRound/ShortListEntryForm/ShortListEntryForm";
import { CreateJuryRoundPost } from "./Components/Admin-Flow-While-Existing-Event/ManageJury/JuryRound/CreateJuryRound/CreateJuryRoundPost";
import { CreateJuryRound } from "./Components/Admin-Flow-While-Existing-Event/ManageJury/JuryRound/CreateJuryRound/CreateJuryRound";
import { JuryAssignment } from "./Components/Admin-Flow-While-Existing-Event/ManageJury/JuryAssignment/JuryAssignment";
import { CustomiseAllocation } from "./Components/Admin-Flow-While-Existing-Event/ManageJury/CustomiseAllocation/CustomiseAllocation";
import { Nominee } from "./Components/Admin-Flow-While-Existing-Event/Manage Entry Form/Nominee/Nominee";
import { Orders } from "./Components/Admin-Flow-While-Existing-Event/Manage Entry Form/Orders/Orders";
import { Entrants } from "./Components/Admin-Flow-While-Existing-Event/Manage Entry Form/Entrants/Entrants";
import { FinanceReport } from "./Components/Admin-Flow-While-Existing-Event/ManageReports/FinanceReport/FinanceReport";
import { JuryScoreReport } from "./Components/Admin-Flow-While-Existing-Event/ManageReports/JuryScoreReport/JuryScoreReport";
import { EntryFormReport } from "./Components/Admin-Flow-While-Existing-Event/ManageReports/EntryFormReport/EntryFormReport";
import { SuccessfullyCreateJudgeRound } from "./Components/Admin-Flow-While-Existing-Event/ManageJury/JuryRound/SuccessfullyCreateJudgeRound/SuccessfullyCreateJudgeRound";
import { EventOverview } from "./Components/Admin-Flow-While-Existing-Event/EventOverview/EventOverview";
import { AwardCategory } from "./Components/Admin-Flow-While-Existing-Event/ManageEvent/AwardCategory/AwardCategory";
import UpdateJuryRound from "./Components/Admin-Flow-While-Existing-Event/ManageJury/JuryRound/UpdateJuryRound/UpdateJuryRound";
import CreateScoreCard from "./Components/Admin-Flow-While-Existing-Event/ManageJury/JuryRound/ScoreCard/CreateScoreCard";
import ScoreCardData from "./Components/Admin-Flow-While-Existing-Event/ManageJury/JuryRound/ScoreCard/ScoreCardData";
import { CreateJuryGroup } from "./Components/Admin-Flow-While-Existing-Event/ManageJury/JuryRound/CreateJuryGroup/CreateJuryGroup";
import { EntryFormListing } from "./Components/Admin-Flow-While-Existing-Event/Manage Entry Form/EntryFormListing/EntryFormListing";
import { JuryEntryListing } from "./Components/Jury-Scoring-Board/JuryEntryListing/JuryEntryListing";
import { JuryScoreBoard } from "./Components/Jury-Scoring-Board/JuryScoreBoard/JuryScoreBoard";
import { JuryDashboard } from "./Components/Jury-Scoring-Board/JuryDashboard/JuryDashboard";
import { TestView } from "./Components/TestView/TestView";
import Page404 from "./Components/404/Page404";
import { EventLivePreview2 } from "./Components/EventLivePreview/EventLivePreview2";
import ProtectedRoute from "./ProtectedRoute";
import ConfirmationModal from "../src/Components/User-Flow-While-Registration/UserLoginPages/UserRegister/ConfirmationModal";
import { useEffect } from "react";
import { JuryUpdateScoreBoard } from "./Components/Jury-Scoring-Board/JuryScoreBoard/JuryUpdateScoreBoard";
import { UserSubmittedData } from "./Components/User-Flow-While-Registration/UserDashboard/UserSubmittedData";
import { CoupanGet } from "./Components/Admin-Flow-While-Existing-Event/Coupans/CoupanGet";
import { ManageEventPlan } from "./Components/Admin-Flow-While-Existing-Event/ManageEvent/EventPlan/ManageEventPlan";
import UserPaymentHistory from "./Components/User-Flow-While-Registration/UserDashboard/UserPaymentHistory";
import PaymentStatusWrapper from "./Components/User-Flow-While-Registration/UserPendingPayment/PaymentStatusWrapper";
import UserSubmissionFetch from "./Components/User-Flow-While-Registration/UserSubmissionFetch";
import TemplatesPage from "./Components/Admin-Flow-While-Existing-Event/Templates/TemplatesPage";
import TemplateEditor from "./Components/Admin-Flow-While-Existing-Event/Templates/TemplateEditor";
import { AdminEdit } from "./Components/User-Flow-While-Registration/UserSubmissionDetails/AdminEdit";
import Manualorders from "./Components/Admin-Flow-While-Existing-Event/Manage Entry Form/Orders/Manualorders";
// import Formapp from "./Components/Admin-Creating-New-Event/MyEvents/RegistrationForm/ParentRegistrationForm/Formapp";

function App() {
  const userCheck = useSelector((state) => state?.users?.userCheck);
  const userRole = useSelector((state) => state?.users?.user?.role);
  console.log(userRole, "plp");
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const isAuthenticated = userCheck && token;

  const userFlowCheck = useSelector((state) => state?.users?.userFlowCheck);
  const userFlowtoken = localStorage.getItem("token");
  const userFlowAuthenticated = userFlowCheck && userFlowtoken;
  useEffect(() => {
    // If token exists, prevent access to login/register pages
    if (token) {
      const restrictedPaths = [
        "/",
        "/login",
        // "/register",
        "/forgetpassword",
        "/otp",
        "/new-password",
        "/user-login",
        "/user-register",
        "/user-forget-password",
        "/user-otp",
        "/user-new-password",
        // "/user-pending-payment",
      ];

      if (restrictedPaths.includes(window.location.pathname)) {
        // Redirect based on role
        navigate(userRole === "admin" ? "/dashboard" : "/user-dashboard");
      }
    }
  }, [navigate, token, userRole]);
  return (
    <div className="App">
      <LoadingProvider>
        <LoaderDot />
        <Layout>
          <ToastContainer />
          <Routes>
            <>
              <Route path="/admin-login" element={<Login />} />
              <Route path="/superadmin-login" element={<Login />} />
              {/* <Route path="/register" element={<Register />} /> */}
              <Route path="/forgetpassword" element={<ForgetPassword />} />
              <Route path="/otp" element={<Otp />} />
              <Route path="/new-password" element={<NewPassword />} />
              <Route path="/" element={<UserLogin />} />
              <Route path="/user-register" element={<UserRegister />} />
              <Route
                path="/user-forget-password"
                element={<UserForgetPassword />}
              />
              <Route path="/user-otp" element={<UserOtp />} />

              <Route path="/user-new-password" element={<UserNewPassword />} />

              <Route
                path="/user-submission-details"
                element={<UserSubmissionDetails />}
              />
              <Route
                path="/submission"
                element={<UserSubmissionFetch />}
              />
              <Route
                path="/user-registration-details"
                element={<UserRegistrationProfile />}
              />
            </>

            {isAuthenticated ? (
              <>
                {/* <Route path="/"  element={<Dashboard />} /> */}
                <Route
                  path="/"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<Dashboard />}
                    />
                  }
                />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<Dashboard />}
                    />
                  }
                />
                <Route
                  path="/my-events"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<MyEvents />}
                    />
                  }
                />
                <Route
                  path="/admin-profile"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<AdminProfile />}
                    />
                  }
                />
                <Route
                  path="/title-bar"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<TitleBar />}
                    />
                  }
                />
                <Route
                  path="/create-new-event"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<CreateNewEvent />}
                    />
                  }
                />
                <Route
                  path="/create-new-event-post"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<CreateNewEventPost />}
                    />
                  }
                />
                <Route
                  path="/create-new-event/:id"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<CreateNewEvent />}
                    />
                  }
                />
                <Route
                  path="/award-categories"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<AwardCategories />}
                    />
                  }
                />
                <Route
                  path="/award-categories-post"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<AwardCategoriesPost />}
                    />
                  }
                />

                <Route
                  path="/stripe-setting"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<StripeSetting />}
                    />
                  }
                />
                <Route
                  path="/test-view"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<TestView />}
                    />
                  }
                />

                <Route
                  path="/sidebar"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<Sidebar />}
                    />
                  }
                />
                {/* ------- */}

                <Route
                  path="/registration-form"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<RegistrationForm />}
                    />
                  }
                />
                <Route
                  path="/edit-field-modal"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<EditFieldModal />}
                    />
                  }
                />
                <Route
                  path="/form-canvas"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<FormCanvas />}
                    />
                  }
                />
                <Route
                  path="/form-preview"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<FormPreview />}
                    />
                  }
                />
                <Route
                  path="/side"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<Side />}
                    />
                  }
                />
                <Route
                  path="/preview-loader"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<LoaderDot />}
                    />
                  }
                />

                {/* Admin Flow While Existing Event ------- */}

                <Route
                  path="/event-overview"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<EventOverview />}
                    />
                  }
                />
                <Route
                  path="/event-details"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<EventDetails />}
                    />
                  }
                />
                <Route
                  path="/submissionid"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<SubmissionId />}
                    />
                  }
                />
                <Route
                  path="/backdoor-access"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<BackdoorAccess />}
                    />
                  }
                />
                <Route
                  path="/award-directory"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<AwardDirectory />}
                    />
                  }
                />
                <Route
                  path="/award-category"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<AwardCategory />}
                    />
                  }
                />
                <Route
                  path="/forms"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<Forms />}
                    />
                  }
                />

                <Route
                  path="/templates"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<TemplatesPage />}
                    />
                  }
                />


                <Route
                  path="/templates/edit/:id"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<TemplateEditor />}
                    />
                  }
                />

                <Route
                  path="/plan"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<ManageEventPlan />}
                    />
                  }
                />
                <Route
                  path="/coupans"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<Coupans />}
                    />
                  }
                />
                <Route
                  path="/get-all-coupans"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<CoupanGet />}
                    />
                  }
                />
                <Route
                  path="/top-bar"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<TopBar />}
                    />
                  }
                />
                <Route
                  path="/jury-round"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<JuryRound />}
                    />
                  }
                />

                <Route
                  path="/jury-round-data"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<JuryRoundExistingData />}
                    />
                  }
                />
                <Route
                  path="/update-jury-post/:roundId"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<UpdateJuryRound />}
                    />
                  }
                />
                <Route
                  path="/upda"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<ScoreCardData />}
                    />
                  }
                />

                <Route
                  path="/create-jury-round-post"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<CreateJuryRoundPost />}
                    />
                  }
                />

                <Route
                  path="/create-jury-round"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<CreateJuryRound />}
                    />
                  }
                />

                <Route
                  path="/successfully-created-judge-round"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<SuccessfullyCreateJudgeRound />}
                    />
                  }
                />

                <Route
                  path="/create-scorecard"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<UpdateJuryRound />}
                    />
                  }
                />

                <Route
                  path="/create-jury-group"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<CreateJuryGroup />}
                    />
                  }
                />

                <Route
                  path="/shortlist-entry-form"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<ShortListEntryForm />}
                    />
                  }
                />

                <Route
                  path="/view-group"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<ViewGroup />}
                    />
                  }
                />
                <Route
                  path="/jury-assignment"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<JuryAssignment />}
                    />
                  }
                />
                <Route
                  path="/customise-allocation"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<CustomiseAllocation />}
                    />
                  }
                />
                <Route
                  path="/nominee-listing"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<Nominee />}
                    />
                  }
                />
                <Route
                  path="/entry-form-listing"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<EntryFormListing />}
                    />
                  }
                />
                <Route
                  path="/adminedit"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<AdminEdit />}
                    />
                  }
                />
                <Route
                  path="/order-list"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<Orders />}
                    />
                  }
                />
                <Route
  path="/manual-payment"
  element={<Manualorders />}
/>
                <Route
                  path="/entrants-list"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<Entrants />}
                    />
                  }
                />
                <Route
                  path="/finance-report"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<FinanceReport />}
                    />
                  }
                />
                <Route
                  path="/jury-score-report"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<JuryScoreReport />}
                    />
                  }
                />
                <Route
                  path="/entry-form-report"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<EntryFormReport />}
                    />
                  }
                />


                <Route
                  path="/test"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<Test />}
                    />
                  }
                />

                {/* Admin Flow While Existing Event ------- */}
              </>
            ) : (
              <>
                {/* <Route path="/login" element={<Navigate to="/login" />} /> */}
                <Route path="/" element={<Navigate to="/login" />} />
              </>
            )}

            {userFlowAuthenticated ? (
              <>
                <Route
                  path="/user-registration-profile"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<UserRegistrationProfile />}
                    />
                  }
                />
                <Route path="/user-dashboard" element={<UserDashboard />} />
                <Route
                  path="/user-titleBar"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<UserTitlebar />}
                    />
                  }
                />
                <Route
                  path="/user-bottom-bar"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<UserBottomBar />}
                    />
                  }
                />
                <Route
                  path="/user-pending-payment"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<UserPendingPayment />}
                    />
                  }
                />

                <Route
                  path="/payment-status"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<PaymentStatusWrapper />}
                    />
                  }
                />

                <Route
                  path="/payment-history"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<UserPaymentHistory />}
                    />
                  }
                />

                <Route
                  path="/user-submission-dashbaord"
                  element={
                    <ProtectedRoute
                      isAuthenticated={token}
                      element={<UserSubmittedData />}
                    />
                  }
                />
              </>
            ) : (
              <>
                <Route path="/UserSubmissionDetails" element={<UserLogin />} />
                <Route path="/user-register" element={<UserRegister />} />
                <Route path="verifyUser" element={<ConfirmationModal />} />
              </>
            )}
            <Route path="*" element={<Page404 />} />
            <Route path="/404" element={<Page404 />} />
            <Route path="/:prefix/:id" element={<EventLivePreview />} />
            <Route path="/:prefix" element={<EventLivePreview2 />} />
            <Route path="/jury-entry-listing" element={<JuryEntryListing />} />

            <Route
              path="/jury-score-board"
              element={
                <JuryScoreBoard />
              }
            />

            <Route
              path="/jury-update-score-board"
              element={
                <JuryUpdateScoreBoard />
              }
            />

            <Route
              path="/jury-dashboard"
              element={
                <JuryDashboard />
              }
            />
          </Routes>
        </Layout>
      </LoadingProvider>
    </div>
  );
}

export default App;
